import { render, staticRenderFns } from "./ExpandableOption.vue?vue&type=template&id=61d8fbf1&scoped=true&"
import script from "./ExpandableOption.vue?vue&type=script&lang=js&"
export * from "./ExpandableOption.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableOption.vue?vue&type=style&index=0&id=61d8fbf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d8fbf1",
  null
  
)

export default component.exports